import { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { EnumFilter, EnumFilterProps } from '../EnumFilter';
import { Option } from '../RadioGroup/RadioGroup';
import {
  ShowButton,
  StyledChevronUp,
  StyledChevronDown,
  DrawerEnumFilterContainer,
  DrawerEnumFilterTheme,
} from './DrawerEnumFilter.styles';

export const DrawerEnumFilter = <T,>(props: EnumFilterProps<T>) => {
  const [shownOptions, setShownOptions] = useState<Option<T>[]>([]);
  const [showingMoreOptions, setShowingMoreOptions] = useState(false);
  const [areHiddenOptions, setAreHiddenOptions] = useState(false);

  useEffect(() => {
    if (props.options.length > 6 && !showingMoreOptions) {
      setShownOptions(props.options.slice(0, 6));
      setAreHiddenOptions(true);
    } else {
      setShownOptions(props.options);
      setAreHiddenOptions(false);
    }
  }, [props.options, setShownOptions, setAreHiddenOptions, showingMoreOptions]);

  return (
    <DrawerEnumFilterContainer>
      <ThemeProvider theme={parentTheme => ({ ...parentTheme, enumFilter: DrawerEnumFilterTheme })}>
        <EnumFilter<T> {...props} options={shownOptions} />
      </ThemeProvider>

      {areHiddenOptions && (
        <ShowButton onClick={() => setShowingMoreOptions(true)}>
          Show More
          <StyledChevronUp />
        </ShowButton>
      )}
      {showingMoreOptions && (
        <ShowButton onClick={() => setShowingMoreOptions(false)}>
          Show Less
          <StyledChevronDown />
        </ShowButton>
      )}
    </DrawerEnumFilterContainer>
  );
};
